var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappBulkCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 380",
    fill: "none",
    role: "img",
    "aria-label": "Campaign marketing dashboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 380,
    rx: 20,
    fill: "#F4F2FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 512,
    height: 36,
    rx: 10,
    fill: "#fff",
    stroke: "#E6DDF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 96,
    height: 12,
    rx: 6,
    fill: "#002454",
    opacity: 0.18
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 32,
    width: 96,
    height: 20,
    rx: 10,
    fill: "#9e00ff",
    opacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 76,
    width: 160,
    height: 88,
    rx: 14,
    fill: "#fff",
    stroke: "#E6DDF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 92,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 108,
    width: 96,
    height: 20,
    rx: 6,
    fill: "#9e00ff",
    opacity: 0.85
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 136,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#25D366",
    opacity: 0.55
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 76,
    width: 160,
    height: 88,
    rx: 14,
    fill: "#fff",
    stroke: "#E6DDF5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 92,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 108,
    width: 96,
    height: 20,
    rx: 6,
    fill: "#002454",
    opacity: 0.75
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 136,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#9e00ff",
    opacity: 0.45
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 76,
    width: 160,
    height: 88,
    rx: 14,
    fill: "#fff",
    stroke: "#E6DDF5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 92,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 108,
    width: 96,
    height: 20,
    rx: 6,
    fill: "#25D366",
    opacity: 0.65
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 136,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.25
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 180,
    width: 512,
    height: 176,
    rx: 14,
    fill: "#fff",
    stroke: "#E6DDF5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 196,
    width: 140,
    height: 10,
    rx: 5,
    fill: "#002454",
    opacity: 0.18
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 220,
    width: 480,
    height: 44,
    rx: 12,
    fill: "#FAFBFD",
    stroke: "#E2E8F0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 234,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.22
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 248,
    width: 220,
    height: 6,
    rx: 3,
    fill: "#002454",
    opacity: 0.12
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 236,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#25D366",
    opacity: 0.55
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 276,
    width: 480,
    height: 44,
    rx: 12,
    fill: "#FAFBFD",
    stroke: "#E2E8F0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 290,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.22
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 304,
    width: 180,
    height: 6,
    rx: 3,
    fill: "#002454",
    opacity: 0.12
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 292,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#9e00ff",
    opacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappBulkCampaign);
export default __webpack_public_path__ + "static/media/whatsapp-bulk-campaign.248d623e15ff9eed6e7aacc3732d63f5.svg";
export { ForwardRef as ReactComponent };